/**
 * Container for Scanner component.
 */
import React from 'react'
import { connect } from 'react-redux'
import { Dispatch, AnyAction } from 'redux'

import { RootStoreState } from '../../root/index'
import { loadItemOnKeypadEntry } from '../../settings/actions'
import { cleanKeypadItems } from '../actions'
import { KeypadItem, ScannerItemType, KeypadEntryStatus } from '../types'
import { SearchIndex } from 'mytours-read-api-typescript'

export interface OwnProps {
	keypadEntryStatus?: KeypadEntryStatus
	items: KeypadItem[]
	loading: boolean
	itemType: ScannerItemType
	itemId: number
}

export interface Props extends OwnProps {
	qrEnabled: boolean
	keypadEnabled: boolean
	searchEnabled: boolean
	searchIndexes: {
		[key: string]: SearchIndex
	}
}

export interface Actions {
	loadItemOnKeypadEntry: (keypadNumber: number) => void
	cleanItems: () => void
}

const mapStateToProps = (state: RootStoreState, ownProps: OwnProps): Props => {
	const appMetaData = state.settings.appMetaData
	let qrEnabled = false
	let keypadEnabled = false
	let searchEnabled = false
	let searchIndexes = appMetaData?.search_indexes ?? {}

	switch (ownProps.itemType) {
		case ScannerItemType.App:
			qrEnabled = Boolean(appMetaData?.qr_enabled)
			keypadEnabled = Boolean(appMetaData?.keypad_enabled)
			searchEnabled = Boolean(appMetaData?.search_enabled)
		break
		case ScannerItemType.Collection:
			const collection = state.collectionlist.collectionDetails.get(ownProps.itemId)
			const item = collection && collection.details ? collection.details : undefined
			qrEnabled = Boolean(item?.qr_enabled)
			keypadEnabled = Boolean(item?.keypad_enabled)
		break
	}

	return {
		keypadEntryStatus: state.scanner.keypadEntryStatus,
		items: state.scanner.items,
		loading: state.scanner.loading,
		itemType: ownProps.itemType,
		itemId: ownProps.itemId,
		qrEnabled,
		keypadEnabled,
		searchEnabled,
		searchIndexes,
	}
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>, ownProps: OwnProps): Actions => ({
	loadItemOnKeypadEntry: (keypadNumber: number) => {
		dispatch(loadItemOnKeypadEntry.started({
			keypadNumber,
			itemType: ownProps.itemType,
			itemId: ownProps.itemId,
		}))
	},
	cleanItems: () => {
		dispatch(cleanKeypadItems({}))
	},
})

export default (Component: React.ComponentType<Props & Actions>) => connect(mapStateToProps, mapDispatchToProps)(Component)
